import Layout from '@/components/Layout';
import Product from '@/components/Product';
import * as Sentry from "@sentry/nextjs";
import styles from '@/components/Product/product.module.scss';
import API from '../../../api';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

// Заглушка для переводов
const translate = s => s;

const Catalog = ({ data = { categories: [] } }) => {
  return <Product data={data} />;
};

const breadcrumbs = [
  { title: translate('Главная'), route: '/' },
  { title: translate('Продукция'), route: '/catalog' },
];

Catalog.getLayout = (page, t) => {
  const category = page.props.data.categories.find(({ products }) =>
    products.map(({ id }) => id).includes(page.props.data.id)
  );
  return (
    <Layout
      page={page.props}
      title={`${
        page.props.data?.title ? page.props.data.title : t(`Каталог продукции`)
      } — UNIFROST`}
      paddings={false}
      customPaddings={styles.paddings}
      breadcrumbs={[
        ...breadcrumbs,
        {
          title: category.title,
          route: `/catalog/category/${category.id}`,
        },
        {
          title: page.props.data.title,
          route: `/catalog/product/${page.props.data.id}`,
        },
      ]}
    >
      {page}
    </Layout>
  );
};

export async function getServerSideProps(context) {
  const props = { data: { categories: [], categoryProducts: [] } };
  const status = 200;

  if (context.params.id) {
    try {
      const res = await API.get(`/v1/api/products/product/${context.params.id}/`, {
        headers: { 'Accept-Language': context.locale },
      });

      if (res.status === 200) {
        if (res.data.id) {
          props.data = { ...props.data, ...res.data };

          const resCategories = await API.get(`/v1/api/products/categories/`, {
            headers: { 'Accept-Language': context.locale },
          });

          if (resCategories.status === 200 && Array.isArray(resCategories.data)) {
            if (resCategories.data) props.data.categories = resCategories.data;
          }

          if (res.data?.category) {
            const resCategoryProducts = await API.get(
              `/v1/api/products/category/${res.data.category}/`,
              {
                headers: { 'Accept-Language': context.locale },
              }
            );

            if (resCategoryProducts.status === 200) {
              if (resCategoryProducts.data && resCategoryProducts.data.products)
                props.data.categoryProducts = resCategoryProducts.data.products;
            }
          }
        }
      }
    } catch (error) {
      Sentry.captureException(error);
      return { notFound: true };
    }
  } else {
    return { notFound: true };
  }

  return {
    props: {
      ...props,
      ...(await serverSideTranslations(context.locale, ['common', 'menu', 'products'])),
    },
    // revalidate: 60,
  };
}

export const getServerSidePaths = async ({ locales }) => {
  const resCategories = await API.get(`/v1/api/products/categories/`);
  const paths = [];
  const plainPaths = resCategories.data
    .map(({ products }) => products)
    .reduce(
      (acc, curr) => [...acc, ...curr.map(({ id }) => ({ params: { id: id.toString() } }))],
      []
    );

  for (const locale of locales) {
    for (const path of plainPaths) {
      paths.push(path);
      paths.push({ ...path, locale });
    }
  }
  return {
    paths,
    fallback: 'blocking',
  };
};

export default Catalog;
